import { CircularProgress } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import {
  defaultCardImage,
  masterCardLogoImage,
  visaImage,
} from "../../../../assets";
import { invokeApi } from "../../../../bl_libs/invokeApi";
import { calculateStripeProcessingFee } from "../../../../ui_libs/Functions/functions";

function ChangesMakePayment(props) {
  const {
    id,
    amount,
    old_amount,
    new_amount,
    ChangeInRequestConfirmation,
    discount,
  } = props;

  const [isAgree, setIsAgree] = useState(false);
  const [cards, setCards] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [errMessage, setErrMessage] = useState("");

  const fetchCardsList = () => {
    let requestObj = {
      path: "/api/customer/checking_card_exist",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {};
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log(res, "CARD RESPONSE");
      if (res.code === 200) {
        //store cards in state
        if (res.retrive_stripe_card) {
          setCards(res.retrive_stripe_card.data);
        }
      } else {
        // remain this empty
        setErrMessage(res.message);
      }
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchCardsList();
  }, []);

  if (isLoading) {
    return (
      <>
        <section id="content-wrapper" className="content-wrapper rating-page">
          <div className="container-fluid">
            <div className="container-fluid">
              <div className="Circular-Progress">
                <CircularProgress />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
  return (
    <>
      <div className="row">
        <div className="col-0 col-sm-2 col-md-2 col-xl-3"></div>
        <div className="col-12 col-sm-8 col-md-8 col-xl-5">
          {/* {errMessage && (
            <Alert variant="filled" severity="error">
              {errMessage}
            </Alert>
          )}
          {warning && (
            <Alert variant="filled" severity="warning">
              {warning}
            </Alert>
          )} */}
          <div className="form-box-wrapper">
            <>
              <span className="mt-4 black-bold-15" id="change-filter-title">
                Pay for the request #{id} to confirm change.
              </span>

              <div className="text-center light-grey-text"></div>
              <div className="form-box pt-20">
                <div className="row small-font-size pt-3">
                  <div className="col-6 text-left overline dark-grey-color">
                    Current Price :
                  </div>
                  <div className="col-6  text-right  dark-grey-color">
                    ${old_amount}
                  </div>
                </div>
                <div className="row small-font-size pt-3">
                  <div className="col-6 text-left overline dark-grey-color">
                    New Price :
                  </div>
                  <div className="col-6  text-right dark-grey-color">
                    ${new_amount}
                  </div>
                </div>
                <div className="row small-font-size pt-3">
                  <div className="col-6 text-left overline dark-grey-color">
                    Charge Price :
                  </div>
                  <div className="col-6  text-right black-color">${amount}</div>
                </div>

                {parseInt(discount) > 0 && (
                  <div className="row">
                    <div className="col-6 text-left overline dark-grey-color pt-3">
                      Discount:
                    </div>
                    <div className="col-6 text-right black-color pt-3">
                      {discount}%{" "}
                    </div>
                    {/* discounted price */}
                    <div className="col-8 text-left overline dark-grey-color pt-3">
                      {amount > 0
                        ? "Discounted Price"
                        : "After Removing Discount"}
                    </div>
                    <div className="col-4 text-right black-color pt-3">
                      ${amount * (1 - parseInt(discount) / 100)}
                    </div>
                  </div>
                )}

                {/* Proccessing fee */}
                <div className="row">
                  <div className="col-6 text-left overline dark-grey-color pt-3">
                    Credit Card Processing Fee:
                  </div>
                  <div className="col-6 text-right black-color pt-3">
                    ${calculateStripeProcessingFee(amount, discount)}
                  </div>
                </div>

                <div className="row pt-4">
                  {cards.map((card) => (
                    <div className="col-12 ">
                      <div className="card-box">
                        {card.brand === "Visa" ? (
                          // Visa
                          <img width="30" src={visaImage}></img>
                        ) : card.brand === "MasterCard" ? (
                          // MasterCard
                          <img src={masterCardLogoImage}></img>
                        ) : (
                          // OtherCards
                          <img width="30" src={defaultCardImage}></img>
                        )}
                        <span className="pl-2">
                          {" "}
                          XX{card.last4.slice(2, 4)}
                        </span>
                        <span
                          className="font-weight-bold"
                          style={{ float: "right" }}
                        >
                          $
                          {discount
                            ? amount * (1 - parseInt(discount) / 100) +
                              calculateStripeProcessingFee(amount, discount)
                            : amount +
                              calculateStripeProcessingFee(amount, discount)}
                        </span>
                      </div>
                    </div>
                  ))}
                  <div className="col-12 change-card-option mt-3 mb-3 pointer-point">
                    {/* Change card  */}
                  </div>
                  <div className="col-12 col-sm-6 mb-3">
                    <label className="dark-grey-color mt-2 custom-checkbox-wrapper">
                      <input
                        required
                        checked={isAgree}
                        onChange={() => setIsAgree(!isAgree)}
                        type="checkbox"
                        name="storage"
                      />
                      <span className="caption dark-grey-color schedule-checkbox">
                        Agree to terms
                      </span>
                      <span className="custom-check-box"></span>
                    </label>
                  </div>
                  <div className="col-12 pt-2 pb-3">
                    <button
                      type="button"
                      onClick={() => {
                        //call function is use checked agree
                        if (isAgree) {
                          ChangeInRequestConfirmation("1", amount);
                        }
                      }}
                      className="red-btn custom-buton custom-buton-large w-100"
                    >
                      {amount > 0
                        ? "Submit payment to escrow"
                        : "Refund payment from escrow"}
                    </button>
                  </div>
                  {/* <div className="col-12">123</div> */}
                </div>
              </div>
            </>
          </div>
        </div>
        <div className="col-0 col-sm-2 col-md-2 col-xl-4"></div>
      </div>
    </>
  );
}

export default ChangesMakePayment;
